import BaseApi from "../baseApi";
import {ORGANIZATION} from "../apiConstant";

const apiWorkManage = new BaseApi(process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL);

class OrganizationFromWorkManageApi {
  search(request) {
    return apiWorkManage.post(`${ORGANIZATION}/search`, request);
  }

}

export default OrganizationFromWorkManageApi;